import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { SELECT_OPTIONS } from '../../common/form/constants/selectOptions';
import RadioButton from '../../common/form/Radio';
import { INPUT_TYPES } from '../../common/form/constants/fieldTypes';
import AccessCode from '../../common/accesscode/AccessCode';
import Error from '../../common/form/errorMessage';
import { ERROR_MESSAGES } from '../../common/form/constants/validationErrorMessages';
import SSN from '../../common/form/ssn/ssn';

import Tooltip from '../../common/tooltip/Tooltip';

export default function accessCodeExpandedView (values, i18nReplacements, handleChange, handleBlur, handleFocus, errors, stateCode) {

    return (
        <Fragment>
            <div className='grid-row gi-component gi-radio_button__nav-tabs'>
                <fieldset className='usa-fieldset'>
                    <legend className='usa-legend margin-b-10'>
                        <span className='required-false'>
                            { stateCode !== 'PA' ?
                                <FormattedMessage id='accounts.accessCode.make_selection'/>
                                :
                                <Tooltip
                                    { ...{
                                        id: 'accounts.accessCode.make_selection',
                                        content: 'accounts.accessCode.make_selection.tooltip',
                                        dataAutomationId: 'access_code_expanded_view_account_accesscode_tooltip'
                                    } }
                                />

                            }
                        </span>
                    </legend>

                    <ul className={'usa-list usa-list--unstyled gi-radio_button__tabs'}>
                        {
                            SELECT_OPTIONS.ACCESSCODE_PAGE_PREFERENCE.map((option, i) => (
                                <RadioButton key={i}
                                    label={{
                                        labelClass: ['grid-row', 'gi-radio_button__label'],
                                        showRequiredIcon: false,
                                        labelText: option.text
                                    }}
                                    inputData={{
                                        id: `accessCode_option_${i}`,
                                        isInputRequired: false,
                                        type: INPUT_TYPES.RADIO_BUTTON,
                                        name: 'accessCodeSelection',
                                        liClass: [''],
                                        value: option.value,
                                        checked: option.value === values.accessCodeSelection,
                                        ariaChecked: option.value,
                                        dataValue: option.value,
                                        ariaLabelledby: `accessCode_option_${i}_label${i}`
                                    }}
                                    errorClasses={['margin-l-0 margin-b-10']}
                                    actions={{
                                        handleFieldChange: handleChange
                                    }}
                                />
                            ))
                        }
                    </ul>
                </fieldset>
            </div>
            <div className='desktop:grid-col-9 tablet:grid-col-9 mobile:grid-col-12 grid-col-12 gi-radio_button__tabs__content'>
                {'accessCode' === values.accessCodeSelection &&
                <Fragment>
                    <AccessCode
                        labelText='accounts.login_success.enter_access_code'
                        labelClasses={['padding-l-0']}
                        isRequired={false}
                        wrapperClasses={['grid-row gi-accesscode margin-t-0']}
                        inputClasses={['grid-col-12']}
                        value={values.accessCode}
                        isInputRequired={false}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        maxLength={10}
                        messageText={i18nReplacements.accessCode}
                        errorWrapperClasses={['access-code__error__wrapper']}
                        errorClasses={['margin-t-10']}
                        //isErrorVisible={}
                    />
                    <Error
                        isVisible={errors.accessCode && errors.accessCode.type === 'required'}
                        messageText={ERROR_MESSAGES.REQUIRED}
                        textReplacements={i18nReplacements.accessCode}
                        errorWrapperClasses={['access-code__error__wrapper']}
                        errorClasses={['center']}
                    />
                    <Error
                        isVisible={errors.accessCode && errors.accessCode.type === 'exactLength'}
                        messageText={ERROR_MESSAGES.NOT_VALID}
                        textReplacements={i18nReplacements.accessCode}
                        errorWrapperClasses={['grid-row', 'margin-tb-5 ','access-code__error__wrapper']}
                        errorClasses={['center']}
                    />
                </Fragment>
                }
                {'ssn' === values.accessCodeSelection &&
                <Fragment>
                    <SSN
                        inputData={{
                            id: 'ssn',
                            name: 'ssn',
                            type: INPUT_TYPES.TEXT,
                            inputClasses: ['grid-col-12'],
                            isRequired: false,
                            isInputRequired: true,
                            wrapperClasses: [],
                            errorWrapperClasses: [],
                        }}
                        label={{
                            labelClasses: ['padding-l-0'],
                            labelText: 'accounts.login_success.enter_ssn'
                        }}
                        legend={{
                            legendText: 'accounts.login_success.dont_have_access_code',
                            helperClasses: ['margin-t-0'],
                        }}
                        error={{
                            errorClasses: []
                        }}
                        actions={{
                            handleFieldChange: handleChange
                        }}
                    />
                    <Error
                        isVisible={errors.ssn && errors.ssn.type === 'exactLength'}
                        messageText={ERROR_MESSAGES.REQUIRED}
                        textReplacements={i18nReplacements.accessCode}
                        errorWrapperClasses={['grid-row', 'margin-tb-5 ','access-code__error__wrapper']}
                        errorClasses={['center']}
                    />
                </Fragment>
                }
            </div>
        </Fragment>
    );
}